<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <!-- Normal menu link -->
    <b-link
      v-if="!item.isLogout"
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>

    <!-- Logout link (special) -->
    <b-link
      v-else
      class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon :icon="item.icon || 'LogOutIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,
      canViewVerticalNavMenuLink,
      t,
    }
  },
  methods: {
    async logout() {
      let loader = this.$loading.show()

      // Clear all local storage keys
      localStorage.removeItem('accessToken')
      localStorage.removeItem('app_env')
      localStorage.removeItem('userData')
      localStorage.removeItem('settingSystem')
      localStorage.removeItem('userDetails')

      // Remove authorization header from axios
      delete axios.defaults.headers.common['Authorization']

      // Clear Vuex store
      this.$store.commit('app/LOGOUT')

      // Redirect to login page
      await this.$router.push({ name: 'login' }).catch(() => {})

      loader.hide()

      // Show success toast
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Success',
          text: 'Successfully logged out.',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })

      // Force reload to reset the application state
      window.location.reload()
    },
  },
}
</script>